import { useMutation, useQueryClient } from "react-query";
import Company from "v2/domain/common/entities/Company";

export default function useChangeCompany() {
  const client = useQueryClient();

  return useMutation(
    async ({ company }: { company: Company }) => {
      return localStorage.setItem("company_id", company.id);
    },
    {
      onSuccess: () => {
        client.invalidateQueries();
        window.location.reload();
      },
    }
  );
}
